import { subMinutes } from 'date-fns';
import LogRocket from 'logrocket';
import template from './recordings.html';

/* @ngInject */
function RecordingsController($timeout, CameraService, growl, appConfig) {
  const vm = this;
  const disableCurrentItemTime = 3000;
  vm.size = _.size;

  const now = new Date();
  const HOUR = 60;

  // //////////////// //
  // PUBLIC VARIABLES //
  // //////////////// //
  vm.apiBaseUrl = appConfig.apiBaseUrl;
  vm.videoRetrievalTimeRange = {
    start: subMinutes(now, HOUR),
    end: now,
  };
  vm.videosForCamera = {
    items: null,
    currentItem: 0,
    disable: {},
  };


  // //////////////// //
  // PUBLIC FUNCTIONS //
  // //////////////// //
  vm.$onInit = init;
  vm.convertVideoTimestamp = (timeString) => {
    // TODO: Linux timestamps are oddly offset by 5 minutes (Mudrekh needs to investigate this)
    const videoLength = 5;
    return new Date(subMinutes(new Date(timeString), videoLength));
  };
  vm.getListOfVideos = getListOfVideos;
  vm.startDownload = startDownload;
  vm.assignCurrent = assignCurrent;
  vm.hasRecordings = () => Boolean(vm.settings.continuousVideo || vm.settings.nvr);

  const BASE_URL = `${appConfig.apiBaseUrl}/equipment/getMediaForEquipment/`;
  const filename = (cameraName, item) => _.includes(item.file, '/') ?
    `${_.snakeCase(cameraName)}_Video_${_.last(item.file.split('/'))}` :
    '';

  function init() {
    _.assign(vm, vm.resolve);

    vm.camera = angular.copy(CameraService.getCamera(vm.panel.id, vm.cameraId));
    vm.settings = vm.camera.settings;
    // selected stream must also exist in camera
    vm.selectedStream = _.keys(vm.cameras).includes(vm.selectedStream) ? vm.selectedStream : _.keys(vm.cameras)[0];
  }

  function getListOfVideos() {
    let growlMessage = growl.info('Getting List Of Videos...', {
      disableCloseButton: true,
    });
    vm.videosForCamera.currentItem = 0;
    CameraService.getListOfVideos(
      vm.cameraId,
      vm.videoRetrievalTimeRange.start,
      vm.videoRetrievalTimeRange.end,
      vm.selectedStream
    )
      .then((success) => {
        _.forEach(success.data, (item) => {
          if (_.has(item, 'thumbnail')) {
            item.thumbnail = `${BASE_URL}${vm.cameraId}?media=${item.thumbnail}`;
          }
          item.href = _.has(item, 'file') ?
            `${BASE_URL}${vm.cameraId}/${filename(vm.camera.name, item)}?media=${item.file}` :
            '#'
          ;
        });
        vm.videosForCamera.items = success.data;
        growlMessage.destroy();
      })
      .catch((res) => {
        growlMessage.destroy();
        const error = 'Error Getting Video List';
        growlMessage = growl.error(res.error, { title: error });
        LogRocket.track(error);
      });
  }

  function startDownload(currentItem) {
    growl.success('Downloading video...');
    vm.videosForCamera.disable[currentItem] = true;
    $timeout(() => {
      vm.videosForCamera.disable[currentItem] = false;
    }, disableCurrentItemTime);
  }

  function assignCurrent(newCurr) {
    vm.videosForCamera.currentItem = newCurr;
  }
}

export default {
  name: 'recordings',
  template,
  controllerAs: 'RecordingsCtrl',
  controller: RecordingsController,
  bindings: {
    resolve: '<',
    dismiss: '&',
  },
};
